import { API_BASE_URL } from './api';
import { getAccessToken } from './auth';

const EXPORT_EVENTS_URL = `${API_BASE_URL}/me/export-events`;

export type ExportEventType = 'png' | 'mp4' | 'browser_session';

export interface ExportEventPayload {
  templateId: string;
  exportType: ExportEventType;
  format?: string;
  resolution?: string;
}

export async function recordExportEvent(payload: ExportEventPayload): Promise<void> {
  const accessToken = await getAccessToken();
  if (!accessToken) {
    return;
  }

  const response = await fetch(EXPORT_EVENTS_URL, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    throw new Error(await readErrorMessage(response, 'Failed to record export event.'));
  }
}

async function readErrorMessage(response: Response, fallback: string): Promise<string> {
  try {
    const payload = (await response.json()) as { error?: string };
    return String(payload?.error || '').trim() || fallback;
  } catch {
    return fallback;
  }
}
